import {AfterViewInit, Component, Input, OnInit, ViewChild} from '@angular/core';
import {NgForm, UntypedFormGroup} from '@angular/forms';
import { StoreService } from '../../../../../../services/store.service';
import { IComponent } from '../../../../../../types/step-component.interface';
import { IValidationSubComponent } from '../../../../../../types/subcomponent-validation.interface';
import {markAllFieldsAsTouched} from "../../../../../../shared/utils";
import {ParentGuardian} from "../../../../../../types/parent-guardian.interface";

@Component({
  selector: 'app-parent-guardian',
  templateUrl: '../parent-guardian.component.html'
})
export class ParentGuardian2Component implements AfterViewInit, OnInit, IValidationSubComponent {
  @Input() metadata: IComponent;
  @Input() instance: string;
  @ViewChild('form') ngForm: NgForm;

  parentGuardianForm: UntypedFormGroup;

  parentGuardian: any;
  zipValidator = /^\d{5}(?:[-\s]\d{4})?$/;
  phoneValidator = /^\d{10}$/;
  states = this.storeService.getCurrentState().states;
  relationships = this.storeService.getCurrentState().relationships;

  constructor(public storeService: StoreService) {}

  ngOnInit() {
    const state = this.storeService.getCurrentState();
    this.parentGuardian = (state['parentGuardian2'] ? state['parentGuardian2'] : { phoneTypeName: 'CELLULAR', state: null });
  }

  ngAfterViewInit() {
    this.parentGuardianForm = this.ngForm.form;
  }

  validate(): boolean {
    markAllFieldsAsTouched(this.parentGuardianForm);
    return this.ngForm.valid;
  }
}
